function MicroFileItemForm({ label, children, isOptional = false }) {
  return (
    <div className="form-label row">
      <div className="col-lg-4">
        <label>{label}</label>
      </div>
      <div className="col-lg-8">
        <div className="form-label-container">
          {children}
          {!isOptional && <span>*</span>}
        </div>
      </div>
    </div>
  );
}

export default MicroFileItemForm;
